import { createSelector } from 'reselect';

export const getCardsRates = state => state.cardsRates || {};

export const getCardsRatesParams = (state, params) => params;

export const makeCardsRatesByDateKey = () =>
  createSelector(getCardsRates, getCardsRatesParams, (rates, { dateKey }) => {
    return rates?.[dateKey] || { entities: { all: [], visa: [], mc: [] } };
  });

export const makeCardsRatesItems = () => {
  const getCardsRatesByDateKey = makeCardsRatesByDateKey();

  return createSelector(
    getCardsRatesByDateKey,
    getCardsRatesParams,
    (rates, { type }) => rates?.entities?.[type] || []
  );
};

export const getCardsRatesItems = makeCardsRatesItems();
